export class Maintenance {
    public id:number|null;
    public text:string;
    public name:string;
    public email_text:string;
    public enabled:boolean;
    public from:Date|null;
    public until:Date|null;

    constructor(data:MaintenanceData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.text = "";
            this.name = "";
            this.email_text = "";
            this.enabled= false;
            this.from = null;
            this.until = null;
        }
        else
        {
            this.id = data.id;
            this.text = data.text;
            this.name = data.name;
            this.email_text = data.email_text;
            this.enabled = data.enabled;

            this.from = null;
            if(data.from !== null)
            {
                this.from = new Date(data.from);
            }

            this.until = null;
            if(data.until !== null)
            {
                this.until = new Date(data.until);
            }
        }
    }

    public resetToDefaults():void {
        this.id = null;
        this.text = "";
        this.name = "";
        this.email_text = "";
        this.enabled = false;
        this.from = null;
        this.until = null;
    }
}

export type MaintenanceData = {
    id:number|null;
    text:string;
    name:string;
    email_text:string;
    enabled:boolean;
    from:Date|null;
    until:Date|null;
}
